// extracted by mini-css-extract-plugin
module.exports = {"container":"HotActivityCard_container__2SUYz","desc":"HotActivityCard_desc__1BKyG"};